import React from "react";
import CreateMaterialForm from "./CreateMaterialForm";
import { createMaterialTypes } from "../../services/MaterialAPI";
import Modal from "../generic/Modal";

interface CreateMaterialTypeFormProps {
    onCloseModal: () => void;
}

const CreateMaterialTypeForm: React.FC<CreateMaterialTypeFormProps> = ({ onCloseModal }) => {
    const formatSuccessMessage = (results: any[]): string => {
        if (!results || results.length === 0) {
            return "";
        }

        const successList = results
            .map((result, idx) => `${idx + 1}. Material type: "${result.material_type}"`)
            .join("\n");

        return `✅ The following material types were created successfully:\n\n${successList}`;
    };

    return (
        <Modal onClose={onCloseModal}>
            <CreateMaterialForm
                title="Create Material Types"
                fieldName="Material Type"
                onSubmit={createMaterialTypes}
                formatSuccessMessage={formatSuccessMessage}
                onCloseModal={onCloseModal}
            />
        </Modal>
    );
};

export default CreateMaterialTypeForm;
